import React, { useEffect, useState } from 'react';
import DataTable from 'react-data-table-component';
import logo from './../Components/LOGO2.png';
import { useAuth } from '../Components/Authentication';
import './../Source/Dashboard.css';
import { Sidebar, Menu, MenuItem, SubMenu } from 'react-pro-sidebar';
import 'flowbite/dist/flowbite.css';
import axios from 'axios';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTachometerAlt } from '@fortawesome/free-solid-svg-icons';
import Main from './Main';
import MapVisitors from './MapVisitors';
import Ranking from './Ranking';
import Visitors from './Visitors';
import Album from './Album';

const apiUrl = process.env.REACT_APP_API_URL;
const debugMode = process.env.REACT_APP_DEBUG_MODE === 'true';

const DataTableComponent = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);

  const [sidebarVisible, setSidebarVisible] = useState(true);
  const [view, setView] = useState('Main'); // 'Participantes','Ranking','Album','Visitantes','Mapa visitantes','Main'

  const VisitantesNames = ['Visitantes', 'Mapa visitantes', 'Errores y TryCatch'];
  const ActividadesNames = ['Participantes', 'Ranking'];

  const toggleSidebar = () => setSidebarVisible(v => !v);

  const handleMenuItemClick = (item) => setView(item);

  useEffect(() => {
    if (!apiUrl) {
      console.error('REACT_APP_API_URL no está configurada.');
      setLoading(false);
      return;
    }

    const source = axios.CancelToken.source();
    setLoading(true);

    axios.get(`${apiUrl}participantes`, { cancelToken: source.token })
      .then(response => {
        // Maneja distintos shapes: response.data.users o response.data
        const users = response?.data?.users ?? response?.data ?? [];
        if (!Array.isArray(users)) {
          console.warn('Formato inesperado de usuarios:', users);
          setData([]);
          return;
        }

        const transformedData = users.map(user => ({
          id: user.use_int_id ?? user.id ?? null,
          nombre: user.use_txt_name ?? user.nombre ?? '',
          apellido: user.use_txt_lastname ?? user.apellido ?? '',
          fecha: user.use_txt_datecreation ?? user.fecha ?? '',
          distrito: user.use_txt_district ?? user.distrito ?? '',
          school: user.use_txt_school ?? user.school ?? ''
        })).filter(u => u.id !== null);

        // ordenar por fecha descendente si la fecha es válida
        transformedData.sort((a, b) => {
          const dateA = a.fecha ? new Date(a.fecha).getTime() : 0;
          const dateB = b.fecha ? new Date(b.fecha).getTime() : 0;
          return dateB - dateA;
        });

        setData(transformedData);
      })
      .catch(err => {
        if (!axios.isCancel(err)) console.error("Error fetching data:", err);
        setData([]);
      })
      .finally(() => setLoading(false));

    return () => source.cancel();
  }, []);

  // Usar selector como función para evitar problemas con versiones/miniﬁcación
  const columns = [
    { name: 'N°', selector: row => row.id, sortable: true, width: '70px' },
    { name: 'Nombre', selector: row => row.nombre, sortable: true },
    { name: 'Apellido', selector: row => row.apellido, sortable: true },
    { name: 'Colegio', selector: row => row.school, sortable: true },
    { name: 'Fecha en la que se unió', selector: row => row.fecha, sortable: true },
    { name: 'Distrito', selector: row => row.distrito, sortable: true },
    {
      name: 'Opciones',
      cell: row => (
        <button
          onClick={() => window.open(`/registros-arboles/${row.id}`, '_blank')}
          type="button"
        >
          Registros
        </button>
      ),
      ignoreRowClick: true,
      allowOverflow: true,
      button: true,
    }
  ];

  const { logout } = useAuth();
  const handleLogout = () => {
    logout && logout();
    window.location.href = '/login';
  }

  return (
    <div className="row">
      <div className="col col-2">
        <button onClick={toggleSidebar}>☰</button>
        <Sidebar collapsed={!sidebarVisible}>
          <Menu>
            <MenuItem>IDENTIARBOL</MenuItem>
            <SubMenu label={<div><FontAwesomeIcon icon={faTachometerAlt} /> Actividades</div>}>
              <SubMenu label="Concurso">
                {ActividadesNames.map(item => (
                  <MenuItem key={item} onClick={() => handleMenuItemClick(item)}>{item}</MenuItem>
                ))}
              </SubMenu>
            </SubMenu>
            <SubMenu label={<div><FontAwesomeIcon icon={faTachometerAlt} /> Bitácora</div>}>
              <SubMenu label="Eventos sistema">
                {VisitantesNames.map(district => (
                  <MenuItem key={district} onClick={() => handleMenuItemClick(district)}>{district}</MenuItem>
                ))}
              </SubMenu>
            </SubMenu>
            <MenuItem onClick={handleLogout}>Cerrar sesión</MenuItem>
          </Menu>
        </Sidebar>
      </div>

      <div className="col">
        {view === 'Participantes' && (
          <DataTable
            title="Participantes"
            columns={columns}
            data={Array.isArray(data) ? data : []}
            progressPending={loading}
            pagination
            highlightOnHover
            responsive
          />
        )}

        {view === 'Ranking' && <Ranking />}
        {view === 'Visitantes' && <Visitors />}
        {view === 'Mapa visitantes' && <MapVisitors />}
        {view === 'Main' && <Main />}
        {view === 'Album' && <Album />}
      </div>
    </div>
  );
};

export default DataTableComponent;
